import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getInfrastructurePhotos(options = {}) {
	return _apiRequestWrap(
		ModulesMap.INFRASTRUCTURE_PHOTOS,
		ModulesConfigMap[ModulesMap.INFRASTRUCTURE_PHOTOS].GET_PHOTOS,
		options
	)
}

function _createInfrastructurePhoto(options = {}) {
	return _apiRequestWrap(
		ModulesMap.INFRASTRUCTURE_PHOTOS,
		ModulesConfigMap[ModulesMap.INFRASTRUCTURE_PHOTOS].CREATE_PHOTO,
		options
	)
}

function _getInfrastructurePhoto(options = {}) {
	return _apiRequestWrap(
		ModulesMap.INFRASTRUCTURE_PHOTOS,
		ModulesConfigMap[ModulesMap.INFRASTRUCTURE_PHOTOS].GET_PHOTO,
		options
	)
}

function _patchInfrastructurePhoto(options = {}) {
	return _apiRequestWrap(
		ModulesMap.INFRASTRUCTURE_PHOTOS,
		ModulesConfigMap[ModulesMap.INFRASTRUCTURE_PHOTOS].PATCH_PHOTO,
		options
	)
}

function _putInfrastructurePhoto(options = {}) {
	return _apiRequestWrap(
		ModulesMap.INFRASTRUCTURE_PHOTOS,
		ModulesConfigMap[ModulesMap.INFRASTRUCTURE_PHOTOS].PUT_PHOTO,
		options
	)
}

function _deleteInfrastructurePhoto(options = {}) {
	return _apiRequestWrap(
		ModulesMap.INFRASTRUCTURE_PHOTOS,
		ModulesConfigMap[ModulesMap.INFRASTRUCTURE_PHOTOS].DELETE_PHOTO,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.INFRASTRUCTURE_PHOTOS].GET_PHOTOS]: _getInfrastructurePhotos,

	[ModulesConfigMap[ModulesMap.INFRASTRUCTURE_PHOTOS].CREATE_PHOTO]: _createInfrastructurePhoto,
	[ModulesConfigMap[ModulesMap.INFRASTRUCTURE_PHOTOS].GET_PHOTO]: _getInfrastructurePhoto,
	[ModulesConfigMap[ModulesMap.INFRASTRUCTURE_PHOTOS].PATCH_PHOTO]: _patchInfrastructurePhoto,
	[ModulesConfigMap[ModulesMap.INFRASTRUCTURE_PHOTOS].PUT_PHOTO]: _putInfrastructurePhoto,
	[ModulesConfigMap[ModulesMap.INFRASTRUCTURE_PHOTOS].DELETE_PHOTO]: _deleteInfrastructurePhoto,
}
